<template>
  <div class="coursePlay">
    <template v-if="data_videoInfo.payBodyType === 1">
      <!-- 课程主体 -->
      <template v-if="data_videoInfo.type === 'F'">
        <!-- 免费课程 -->
        <dl v-if="!item.video.vid" class="amount">
          <dd>
            即将上线
          </dd>
        </dl>
        <a-button v-else-if="item.videoType === 'O'" type="primary">概要</a-button>
        <a-button v-else-if="item.isTrial === 'T' && !userId" type="primary">试看</a-button>
        <i v-else>
          <PlayCircleFilled />
        </i>
      </template>
      <template v-else>
        <!-- 付费课程 -->
        <dl v-if="!item.video.vid" class="amount">
          <dd>
            即将上线
          </dd>
        </dl>
        <a-button v-else-if="item.videoType === 'O'" type="primary">概要</a-button>
        <a-button v-else-if="item.isTrial === 'T' && data_videoInfo.userCourseStatus !== 'W'"
                  type="primary">试看</a-button>
        <i v-else-if="data_videoInfo.userCourseStatus === 'W'">
          <PlayCircleFilled />
        </i>
      </template>
    </template>


    <template v-if="data_videoInfo.payBodyType === 2">
      <!-- 章节主体 -->
      <template v-if="item.type === 1">
        <!-- 免费课程 -->
        <dl v-if="!item.video.vid" class="amount">
          <dd>
            即将上线
          </dd>
        </dl>
        <a-button v-else-if="item.videoType === 'O'" type="primary">概要</a-button>
        <a-button v-else-if="item.isTrial === 'T' && !getUserId()" type="primary">试看</a-button>
        <i v-else>
          <PlayCircleFilled />
        </i>
      </template>
      <template v-else-if="item.type === 2">
        <!-- 付费课程 -->
        <dl v-if="!item.video.vid" class="amount">
          <dd>
            即将上线
          </dd>
          <dd v-if="item.payStatus === 'F'">
            <span v-if="toPayFor_n !== 2">￥</span>
            <b>{{item.courseVideoDiscountPrice?item.courseVideoDiscountPrice:item.price}}</b>
            <span v-if="toPayFor_n === 2">神贝</span>
          </dd>
        </dl>
        <a-button v-else-if="item.videoType === 'O'" type="primary">概要</a-button>
        <a-button v-else-if="item.isTrial === 'T' && item.payStatus === 'F'" type="primary">试看</a-button>
        <dl v-else-if="item.payStatus === 'F'" class="amount">
          <dd v-if="item.courseVideoDiscountPrice">
            限时优惠
          </dd>
          <dd>
            <span v-if="toPayFor_n !== 2">￥</span>
            <b>{{item.courseVideoDiscountPrice?item.courseVideoDiscountPrice:item.price}}</b>
            <span v-if="toPayFor_n === 2">神贝</span>
          </dd>
        </dl>
        <i v-else-if="item.payStatus === 'T'">
          <PlayCircleFilled />
        </i>
      </template>
    </template>
  </div>
</template>
<script>
  import { button } from "ant-design-vue";
  import { PlayCircleFilled } from "@ant-design/icons-vue";
  import { getUserId } from "@/utils/methods.js";
  export default {
    name: 'CourseList',
    components:{
      PlayCircleFilled,
      [button.name]: button,
    },
    // toPayFor_n：支付类型（神贝或者￥），可不传
    props:['data_videoInfo','item','toPayFor_n'],
  }
</script>
<style lang="scss" scoped>
  .coursePlay {
    display: flex;

    button {
      display: inline-block;
      width: 80px;
      height: 32px;
      border-radius: 6px;
      color: #fff !important;
      text-align: center;
      background: $theme_blue;
    }

    i {
      font-size: 32px;
      width: 80px;
      display: inline-block;
      text-align: center;
      color: #c3c3c3;
    }

    span {
      font-weight: 500;
    }

    .amount {
      display: flex;
      align-items: baseline;
      margin-right: 25px;

      dd {
        font-size: 16px;
        color: #FF6624;
        display: flex;
        align-items: baseline;

        &:last-of-type {
          margin-left: 10px;
        }

        b {
          font-weight: bold;
          font-size: 22px;
        }
      }
    }
  }
</style>
